import { AlertColor } from '@mui/material';
import { EnqueueSnackbar } from 'notistack';
import { ErrorCode, FileRejection } from 'react-dropzone';

export const setAlert = (enqueueSnackbar: EnqueueSnackbar, message: string, variant?: AlertColor) => {
  enqueueSnackbar({
    message: message,
    variant: variant || 'warning',
    preventDuplicate: true,
  });
};

export const handleFileRejections = (
  enqueueSnackbar: EnqueueSnackbar,
  fileRejections: FileRejection[],
  maxSize: number,
  maxFiles: number,
) => {
  fileRejections.forEach(({ file, errors }) => {
    errors.forEach((error) => {
      if (error.code === ErrorCode.FileTooLarge) {
        setAlert(
          enqueueSnackbar,
          `The file "${file.name}" exceeds the size limit of ${(
            maxSize / 1048576
          ).toFixed(1)} MB.`,
          'error',
        );
      } else if (error.code === ErrorCode.FileInvalidType) {
        setAlert(
          enqueueSnackbar,
          'The file has an unsupported format. Supported formats: .XLS, .XLSX.',
          'error',
        );
      } else if (error.code === ErrorCode.TooManyFiles) {
        setAlert(enqueueSnackbar, `You can only upload up to ${maxFiles} files.`);
      } else {
        setAlert(enqueueSnackbar, `The file "${file.name}" could not be uploaded due to an unknown error.`,
          'error',
        );
      }
    });
  });
};

export const validateFileType = (file: File) => {
  const allowedTypes = [
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    'application/vnd.ms-excel'
  ];
  return allowedTypes.includes(file.type);
};